// V1 source: customer/midas/components/MidasArtifactSRDetail.tsx
// Strategy: wraps-platform-component
// Verified no-MUI: yes (this wrapper file is MUI-free; the wrapped
//   <ServiceReportDetailView compact /> uses MUI internally — that's
//   the Round 10 invariant for wrapped platform components.)
//
// V2 SR detail viewer — Tier B forward-compat. Thin pass-through to
// the canonical <ServiceReportDetailView compact /> from the machinery
// module. The platform component owns its own data-fetching via Redux
// thunks (`getServiceReport`, `getMachineParts`) keyed by
// reportNumber + machineId, so this wrapper just unpacks the artifact
// payload and passes the props through.
//
// Required context (already available at /midas-v2):
//   - Redux store (chat panel + machine card viewer use the same store).
//   - React Router `useNavigate` for "Open full page" deep-link.
//   - `myMachinery` i18n namespace (consumed inside ServiceReportDetailView).
//   No new wiring needed.
//
// `compact` mode is what V1 dock used — it suppresses the page chrome
// and renders just the SR cards in a stack suitable for a side panel.

import React from "react";
import { useNavigate } from "react-router-dom";

import ServiceReportDetailView from "../../../machinery/components/srDetail/ServiceReportDetailView";
import { ArtifactTab } from "../../midasPageModels";

interface Props {
  tab: ArtifactTab;
}

const MidasArtifactSRDetailV2: React.FC<Props> = ({ tab }) => {
  const navigate = useNavigate();
  const data = (tab.artifact.data || {}) as {
    reportNumber?: string;
    machineId?: string;
  };

  const reportNumber = data.reportNumber || "";
  const machineId = data.machineId || "";

  const handleOpenFullPage = () => {
    if (machineId && reportNumber) {
      navigate(`/machinery/${machineId}/service-reports/${reportNumber}`);
    }
  };

  // Guard — without both ids the platform component can't fetch.
  // Returning null lets the parent ErrorBoundary surface the fallback
  // panel chrome (matches V1 behavior).
  if (!reportNumber || !machineId) return null;

  return (
    <div className="flex flex-1 flex-col overflow-auto">
      <ServiceReportDetailView
        reportNumber={reportNumber}
        machineId={machineId}
        compact
        onOpenFullPage={handleOpenFullPage}
      />
    </div>
  );
};

export default MidasArtifactSRDetailV2;
